import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PostCommentsPage } from './post-comments.page';

const routes: Routes = [
  {
    path: '',
    component: PostCommentsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PostCommentsPageRoutingModule {}
